<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="所属组织">
          <el-select v-model="formInline.affiliated_organization" placeholder="请选择所属组织" clearable style="width: 180px;">
            <el-option label="所有" value=""></el-option>
            <el-option v-for="item in organizationList" :key="item.ma_organization_id" :label="item.name" :value="item.ma_organization_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会议名称">
          <el-input placeholder="请输入会议名称" v-model="formInline.name" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="周期">
          <el-select v-model="formInline.cycle" placeholder="请选择周期" clearable style="width: 180px;">
            <el-option label="所有" value=""></el-option>
            <el-option label="日" value="日"></el-option>
            <el-option label="周" value="周"></el-option>
            <el-option label="月" value="月"></el-option>
            <el-option label="季" value="季"></el-option>
            <el-option label="年" value="年"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="综合查询">
          <el-input placeholder="请输入综合查询内容" v-model="formInline.search" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          <!-- <el-button size="small" icon="el-icon-download" @click="exportData">导出Excel{{ selectedRows.length > 0 ? '(' + selectedRows.length + ')' : '' }}</el-button>
          <el-button size="small" icon="el-icon-upload2" @click="importClick">导入</el-button> -->
        </el-form-item>
      </el-form>
    </div>

    <!-- <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加会议</el-button>
    </div> -->

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="name" label="会议名称" width="150"></el-table-column>
            <el-table-column prop="affiliated_organization" label="所属组织" width="120"></el-table-column>
            <el-table-column prop="employee_name" label="姓名" width="100"></el-table-column>
            <el-table-column prop="id_card" label="身份证号" width="180"></el-table-column>
            <el-table-column prop="identity" label="身份" width="100"></el-table-column>
            <el-table-column prop="start_end_time" label="起止时间" width="200"></el-table-column>
            <el-table-column prop="meeting_duration" label="本次会议时长" width="120"></el-table-column>
            <el-table-column prop="completed_duration" label="本次完成时长" width="120"></el-table-column>
            <el-table-column prop="scene" label="场景" width="100"></el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
                  {{ scope.row.status === 1 ? '已完成' : '进行中' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :ma_meeting_id="ma_meeting_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Import :open_import="open_import" v-if="open_import" @close="closeImport"></Import>
    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible'
                :close-on-click-modal="false"
                :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>

  </div>
</template>

<script>
import Ma_meetingApi from '@/api/ma_meeting.js';
import Ma_organizationApi from '@/api/ma_organization.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';
import Import from './part/import.vue';

export default {
  components: {
    Add,
    Edit,
    Import,
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search:"",
        name:"",
        affiliated_organization:"",
        cycle:""
      },
      organizationList: [],

      open_add:false,
      open_edit:false,
      ma_meeting_id:"",
      dialogVisible:false,
      open_import:false,
      /*选中的*/
      selection: [],
      selectedRows: [], // 选中的行数据
    };
  },
  created() {
    this.loadOrganizations();
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    loadOrganizations() {
      let self = this;
      Ma_organizationApi.list({}, true)
          .then(data => {
            if (data.code == 1) {
              self.organizationList = data.data.list.data;
            }
          })
          .catch(error => {
          });
    },

    dialogFormVisible(){
      this.dialogVisible = false;
    },
    setting(e){//会议标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /* 多选框选择变化 */
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    /* 清空选择 */
    clearSelection() {
      if (this.multipleTable) {
        this.multipleTable.clearSelection();
      }
      this.selectedRows = [];
    },
    closeImport(e) {
      this.open_import = false;
      if (e.type === "success") {
        this.getTableList(); // 导入成功后刷新列表
      }
    },
    importClick() {
      this.open_import = true;
    },
    exportData() {
      let exportParams = {
        name: this.formInline.name,
        affiliated_organization: this.formInline.affiliated_organization,
        cycle: this.formInline.cycle,
        search: this.formInline.search
      };

      if (this.selectedRows.length > 0) {
        const selectedIds = this.selectedRows.map(row => row.ma_meeting_id);
        exportParams.selected_ids = selectedIds.join(',');
      }

      let baseUrl = window.location.protocol + '//' + window.location.host;
      let queryString = Object.keys(exportParams)
          .filter(key => exportParams[key] !== '' && exportParams[key] !== undefined && exportParams[key] !== null)
          .map(key => `${key}=${encodeURIComponent(exportParams[key])}`)
          .join('&');

      window.location.href = baseUrl + '/index.php/shop/plus.ma_meeting.Index/export?' + queryString;
    },
    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      Ma_meetingApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
    },

    /*重置搜索*/
    resetSearch() {
      this.formInline = {
        search:"",
        name:"",
        affiliated_organization:"",
        cycle:""
      };
      this.curPage = 1;
      this.getTableList();
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true
    },

    /*编辑活动*/
    editClick(row) {
      this.ma_meeting_id = row.ma_meeting_id;
      this.open_edit = true
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Ma_meetingApi.del(
                {
                  ma_meeting_id: row.ma_meeting_id
                },
                true
            )
                .then(data => {
                  if (data.code == 1) {
                    self.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.getTableList();
                  } else {
                    self.$message.error('错了哦，这是一条错误消息');
                  }
                })
                .catch(error => {
                });
          })
          .catch(() => {
          });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/ma_meeting/index/index.vue